module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "lxm-tag tag",
    style: ({
      backgroundColor: _vm.color
    }),
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d49c2ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d49c2ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmTag.vue
// module id = 849
// module chunks = 0